import React from 'react';
import cx from 'classnames';
import { BadgeProps } from 'src/model/componentTypes';
import { ReactComponent as CloseIcon } from 'src/assets/icons/remove-icp-icon.svg';
const Badge = React.forwardRef<HTMLSpanElement, BadgeProps>(
  (
    {
      content,
      type,
      style,
      onClick,
      icon: IconComponent,
      endIcon: EndIconComponent,
      className,
      iconRight,
      id,
      onIconClick,
      onEndIconClick,
      version = 'v1',
      deleteFilter,
      filter,
      textSize = 'medium',
      ...props
    },
    ref,
  ) => {
    const badgeClass = cx(className ? className : '', {
      'badge-position': iconRight,
      'badge-component': version === 'v1',
      'badge-component-v2': version === 'v2',
      'badge-hover': onClick,
      'badge-error': type === 'error',
      'badge-success': type === 'success',
      'badge-warning': type === 'warning',
      'badge-basic': type === 'basic',
      'badge-muted': type === 'muted',
      'badge-blue': type === 'blue',
      'badge-white': type === 'white',
      'badge-primary': type === 'primary',
      'badge-primary-light': type === 'primary-light',
    });
    const iconClass = cx({
      'badge-icon-component': true,
      'icon-error': type === 'error',
      'icon-success': type === 'success',
      'icon-warning': type === 'warning',
      'icon-basic': type === 'basic',
      'icon-muted': type === 'muted',
      'icon-blue': type === 'blue',
      'icon-white': type === 'white',
      'icon-primary': type === 'primary',
    });
    const EndIconClass = cx({
      'badge-icon-component-end': true,
      'icon-error': type === 'error',
      'icon-success': type === 'success',
      'icon-warning': type === 'warning',
      'icon-basic': type === 'basic',
      'icon-muted': type === 'muted',
      'icon-blue': type === 'blue',
      'icon-white': type === 'white',
      'icon-primary': type === 'primary',
    });

    const textSizeStyles = {
      small: '0.625rem',
      medium: '0.875rem',
      large: '1.125rem',
    };

    const textStyle: React.CSSProperties = {
      fontSize: textSizeStyles[textSize as keyof typeof textSizeStyles] || textSize,
    };

    return (
      <span {...props} ref={ref} id={id} style={style} className={badgeClass} onClick={onClick}>
        {filter && (
          <>
            {typeof content === 'string' ? (
              <p style={textStyle}>
                {content}{' '}
                <CloseIcon
                  onClick={() => {
                    deleteFilter && deleteFilter(content, filter, 'includes', false, false);
                  }}
                  className="remove-btn"
                />
              </p>
            ) : (
              content
            )}
          </>
        )}
        {IconComponent &&
          (!React.isValidElement(IconComponent) ? (
            <IconComponent onClick={onIconClick} className={iconClass} />
          ) : (
            React.cloneElement(IconComponent as React.ReactElement, {
              onClick: onIconClick,
              className: iconClass,
            })
          ))}
        {!filter && (
          <>{typeof content === 'string' ? <p style={textStyle}>{content}</p> : content}</>
        )}
        {EndIconComponent &&
          (!React.isValidElement(EndIconComponent) ? (
            <EndIconComponent onClick={onEndIconClick} className={EndIconClass} />
          ) : (
            React.cloneElement(EndIconComponent as React.ReactElement, {
              onClick: onEndIconClick,
              className: EndIconClass,
            })
          ))}
      </span>
    );
  },
);

Badge.displayName = 'Badge';

export default Badge;
